(() => {
  const root = document.querySelector('[data-nm-home]');
  if (!root || root.dataset.enhanced === 'true') return;
  root.dataset.enhanced = 'true';
  const slider = root.querySelector('[data-nm-slider]');
  if (slider) {
    const slides = [...slider.querySelectorAll('[data-nm-slide]')];
    const dots = slider.querySelector('[data-nm-dots]');
    let current = 0;
    let timer;
    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      [...dots.children].forEach((dot, i) => { dot.classList.toggle('is-active', i === current); dot.setAttribute('aria-current', i === current ? 'true' : 'false'); });
    };
    const restart = () => { window.clearInterval(timer); if (slides.length > 1) timer = window.setInterval(() => show(current + 1), 4000); };
    slides.forEach((_, i) => { const dot = document.createElement('button'); dot.type = 'button'; dot.setAttribute('aria-label', `Go to slide ${i + 1}`); dot.addEventListener('click', () => { show(i); restart(); }); dots.appendChild(dot); });
    slider.querySelector('[data-nm-prev]')?.addEventListener('click', () => { show(current - 1); restart(); });
    slider.querySelector('[data-nm-next]')?.addEventListener('click', () => { show(current + 1); restart(); });
    show(0); restart();
  }
  root.querySelectorAll('[data-nm-tab]').forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.nmTab;
      root.querySelectorAll('[data-nm-tab]').forEach((item) => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', active ? 'true' : 'false'); });
      root.querySelectorAll('[data-nm-panel]').forEach((panel) => { const active = panel.dataset.nmPanel === target; panel.classList.toggle('is-active', active); panel.hidden = !active; });
    });
  });
})();
